import React from "react";
import Innings from "./Innings";
import Result from "./Result";
import SportAction from "../../Actions/SportAction";
import AnimationComponent from "../../Helper/AnimationComponent";

export default class SportsWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      resp: null,
      errormsg: {},
      queryparams: props.queryparams,
      searchparams: props.location.search,
      networkerror: false
    };
    this.fetchData = this.fetchData.bind(this);
  }

  componentWillMount() {
    // console.log();
    // console.log("componentWillMount");
    this.fetchData();
  }
  componentDidMount() {
    // this.fetchData();
  }
  fetchData() {
    let params = this.state.queryparams;
    let request = SportAction.cricket({
      match_id: params["match_id"],
      accessToken: params["token"],
      lang: params["lang"],
      islive: params['islive'] && params['islive'] == 1 ? "islive" : ""
    });

    request.then(response => {
      try {
        if (response["data"]["data"]) {
            this.setState(
              {
                resp: response["data"]["data"]
              },
              () => { }
            );
          

        }
      } catch (e) { }
    }).catch(error => {
      this.setState(
        {
          networkerror: true
        },
        () => { }
      );
    });
  }

  render() {
    console.log(this.state.queryparams);
    if (this.state.resp) {
      // if (false) {
      let resp = this.state.resp;
      return (
        <div className="backblack">
          <div className="sports_widget_container">
            {/* for completed match  */}
            {resp.status_str == "Completed" ? <Result searchparams={this.state.searchparams} res={this.state.resp} /> : ""}
            {resp.status_str == "Cancelled" ? <Result searchparams={this.state.searchparams} res={this.state.resp} /> : ""}
            {resp.status_str == "Scheduled" ? <Result searchparams={this.state.searchparams} res={this.state.resp} /> : ""}

            {resp.status_str == "Live" ? (
              <Innings
                searchparams={this.state.searchparams}
                res={this.state.resp}
                fetchData={this.fetchData}
              />
            ) : (
                ""
              )}
          </div>
        </div>
      );
    } else if (this.state.networkerror) {
      return (
        <div
          className="backblack"
          style={{ position: "relative", height: "240px" }}
        >
          <div className="sports_widget_container" />
          <section className="error_prompt_popup">
            <h4>network error!</h4>
          </section>
        </div>
      );
    } else {
      return (
        <div
          className="sports_widget_container"
          style={{ "minHeight": "300px" }}
        />
      );
    }
  }
}
